module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.company_slug == 'klp') ? _c('div', [_vm._m(0), _vm._v(" "), (_vm.view == 'main') ? _c('div', [_c('h3', [_vm._v("Ble bilen reparert? ")]), _vm._v(" "), _c('div', {
    staticClass: "fd-status-wrap"
  }, [_c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finish_status),
      expression: "finish_status"
    }],
    attrs: {
      "type": "radio",
      "id": "finish_status-positive",
      "value": "-1"
    },
    domProps: {
      "checked": _vm._q(_vm.finish_status, "-1")
    },
    on: {
      "change": function($event) {
        _vm.finish_status = "-1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "finish_status-positive"
    }
  }, [_vm._v("Nei")])]), _vm._v(" "), _c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finish_status),
      expression: "finish_status"
    }],
    attrs: {
      "type": "radio",
      "id": "finish_status-negative",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.finish_status, "1")
    },
    on: {
      "change": function($event) {
        _vm.finish_status = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "finish_status-negative"
    }
  }, [_vm._v("Ja")])]), _vm._v(" "), (_vm.localErrors.finish_status) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.localErrors.finish_status)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.finish_status) ? _c('div', [(_vm.finish_status < 0) ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send()
      }
    }
  }, [_vm._v("Send")]) : _vm._e(), _vm._v(" "), (_vm.finish_status > 0) ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.view = 'form'
      }
    }
  }, [_vm._v("Neste")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.view == 'form') ? _c('div', [_c('h3', [_vm._v("Ble det brukt forsikring?")]), _vm._v(" "), _c('div', {
    staticClass: "fd-status-wrap"
  }, [_c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance_status),
      expression: "insurance_status"
    }],
    attrs: {
      "type": "radio",
      "id": "insurance-status-positive",
      "value": "-1"
    },
    domProps: {
      "checked": _vm._q(_vm.insurance_status, "-1")
    },
    on: {
      "change": function($event) {
        _vm.insurance_status = "-1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "insurance-status-positive"
    }
  }, [_vm._v("Nei")])]), _vm._v(" "), _c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance_status),
      expression: "insurance_status"
    }],
    attrs: {
      "type": "radio",
      "id": "insurance-status-negative",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.insurance_status, "1")
    },
    on: {
      "change": function($event) {
        _vm.insurance_status = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "insurance-status-negative"
    }
  }, [_vm._v("Ja")])])]), _vm._v(" "), (_vm.localErrors.insurance_status) ? _c('div', [_c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.localErrors.insurance_status)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finish_price),
      expression: "finish_price"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Pris"
    },
    domProps: {
      "value": (_vm.finish_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finish_price = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.localErrors.finish_price) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.localErrors.finish_price)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.insurance_status > 0) ? _c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finish_damage_numbers),
      expression: "finish_damage_numbers"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Skadenummer"
    },
    domProps: {
      "value": (_vm.finish_damage_numbers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finish_damage_numbers = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.localErrors.finish_damage_numbers) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.localErrors.finish_damage_numbers)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send()
      }
    }
  }, [_vm._v("Send inn")])])]) : _vm._e()]) : _c('div', [_c('p', [_vm._v("Dette merker tilbudet som ferdig reparert og sender mail til oppdragsgiver")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close()
      }
    }
  }, [_vm._v("Avbryt")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send()
      }
    }
  }, [_vm._v("Send")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("sentiment_very_satisfied")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-356d339e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/tags/FinishDialog.vue
// module id = 109
// module chunks = 0